import { createReducer } from '@reduxjs/toolkit'
import { map, without } from 'lodash'
import ActionTypes from '@constants/action_types.js'
import { mergeEntity, mergeEntities } from '@utils/object.js'

export const initialState = {}

export const marker = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.RECEIVE_MARKER, (state, action) => receiveMarker(state, action))
    .addCase(ActionTypes.RECEIVE_MARKERS, (state, action) => receiveMarkers(state, action))
    .addCase(ActionTypes.PHOTO_DELETE_SUCCESS, (state, action) => removePhoto(state, action))
    .addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => receiveEntities(state, action))
    .addCase(ActionTypes.REMOVE_ENTITY, (state, action) => removeEntity(state, action))
})

export default marker

function getDefaultAttributes() {
  return {
    id: 0,
    timeline_id: 0,
    title: '',
    description: '',
    photo_ids: [],
    date: '1978-12-24 00:00:00',
  }
}

function receiveMarker(state, action) {
  const { payload: marker } = action
  mergeEntity(state, marker, getDefaultAttributes())
  return state
}

function receiveMarkers(state, action) {
  const { payload: markers } = action
  mergeEntities(state, markers, getDefaultAttributes())
  return state
}

function removePhoto(state, action) {
  const { payload: photoId } = action
  map(state, marker => {
    if (marker.photo_ids.includes(photoId)) {
      marker.photo_ids = without(marker.photo_ids, photoId)
    }
  })
  return state
}

function receiveEntities(state, action) {
  const { payload } = action
  if (payload.hasOwnProperty('marker')) {
    const { marker: entity } = payload
    state = mergeEntity(state, entity, getDefaultAttributes())
  }
  if (payload.hasOwnProperty('markers')) {
    const { markers: entities } = payload
    state = mergeEntities(state, entities, getDefaultAttributes())
  }
  return state
}

function removeEntity(state, action) {
  const { payload } = action
  const { entityId, entityType } = payload
  if (entityType === 'marker') {
    delete state[entityId]
  }
  return state
}
